import { IS_PRODUCTION, IS_STAGING } from '../../environment';

export function AppConfig(
  $urlRouterProvider,
  $locationProvider,
  $logProvider,
  $animateProvider,
  $httpProvider,
  $compileProvider
) {
  'ngInject';
  // Enable applyAsync
  // REF:
  //    https://docs.angularjs.org/api/ng/provider/$httpProvider
  //    https://docs.angularjs.org/api/ng/type/$rootScope.Scope#$applyAsync
  $httpProvider.useApplyAsync(true);

  // Disable logging
  $logProvider.debugEnabled(true);

  // Enable HTML push state mode
  $locationProvider.html5Mode(true);

  // Unmatched urls
  $urlRouterProvider.otherwise($injector =>
    $injector.get('$state').go('app.welcome')
  );

  // Limit angular-animate to specific classes to limit performance impact.
  $animateProvider.classNameFilter(/u-animate/);

  // Disable debugging info for production
  // Also disable debugging info for staging to benefit A/B testing
  // https://docs.angularjs.org/guide/production
  $compileProvider.debugInfoEnabled(!(IS_PRODUCTION || IS_STAGING));

  // Disable comment / css directives since we don't use them and can
  // cause performance issues in production
  // https://docs.angularjs.org/guide/production
  $compileProvider.commentDirectivesEnabled(false);
  $compileProvider.cssClassDirectivesEnabled(false);
}
